import { Experience } from '@/components';

export const Play3D = () => {
	return (
		<main className="h-screen">
			<Experience />
		</main>
	);
};
